export const getTotalParticipants = variants => {
  let participants = 0;
  for (const variant of variants) {
    // the field was emptied by the user so we dont want a NaN result
    if (variant.participant == '') continue;

    participants += parseInt(variant.participant);
  }
  return participants;
};
